// extracted by mini-css-extract-plugin
export var details = "_lf-0";
export var inspectorPopover = "_lf-1";